import { render } from "./VueflowGraph.vue?vue&type=template&id=25bc6490"
import script from "./VueflowGraph.vue?vue&type=script&lang=js"
export * from "./VueflowGraph.vue?vue&type=script&lang=js"

import "./VueflowGraph.vue?vue&type=style&index=0&id=25bc6490&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__